module.exports = __webpack_public_path__ + "12d096b5369af280ca07bdd62f2f7bdb.pdf";